angular.module('ui.order.orderItemCard.orderItemInfo', [])

    .directive('orderItemInfo', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/ui/order/orderItemCard/orderItemInfo/orderItemInfo.html',
            controller: 'OrderItemInfoController'
        };
    })

    .controller('OrderItemInfoController', function ($scope, orderItemCardDataProvider) {

        orderItemCardDataProvider.onDataChange('OrderItemInfoController', function () {
            initData();
        });

        $scope.$on("$destroy", function () {
            orderItemCardDataProvider.onDataChange('OrderItemInfoController', void 0);
        });

        function initData() {
            $scope.orderItemId = orderItemCardDataProvider.getOrderItemId();

            if (!$scope.orderItemId) {
                $scope.orderItem = null;
                $scope.step = null;
                $scope.order = null;
                $scope.categories = null;
                $scope.orderItemCategories = null;
                $scope.categoryTypes = null;
            } else {
                $scope.orderItem = orderItemCardDataProvider.getOrderItem();
                $scope.step = orderItemCardDataProvider.getStep();
                $scope.order = orderItemCardDataProvider.getOrder();
                $scope.categories = orderItemCardDataProvider.getCategories();
                $scope.orderItemCategories = orderItemCardDataProvider.getOrderItemCategories();
                $scope.categoryTypes = orderItemCardDataProvider.getCategoryTypes();
            }
        }

    })

;